import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import VerifiedIcon from '@mui/icons-material/Verified';

interface SupportsItem {
  product: string;
  image: string;
}

export default function Supports() {
  const [supportsItems, setSupportsItems] = useState<SupportsItem[]>([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/supports.json`)
      .then(response => response.json())
      .then((data: SupportsItem[]) => setSupportsItems(data))
      .catch(error => console.error('Error fetching support data:', error));
  }, []);
  return (
    <Box
      id="supports"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" color="text.primary">
            Opinie klientów
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Zobacz na opinie wspieranych przez nas!
          </Typography>
        </Box>
        <Grid container spacing={2.5}>
          {supportsItems.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  p: 3,
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'text.primary',
                  background: 'transparent',
                  backgroundColor: 'background',
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <img
                    src={item.image}
                    alt={`Logo ${index + 1}`}
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                </Box>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
